<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="55vh"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="55"> </el-table-column>

			<el-table-column prop="id" label="id" width="80px"> </el-table-column>
			<el-table-column prop="title" label="活动名称"> </el-table-column>
			<el-table-column label="举办类型">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 5">线上活动</span>
					<span v-if="scope.row.type == 6">线下活动</span>
				</template>
			</el-table-column>

			<el-table-column prop="mainevent" label="类型"> </el-table-column>
			<el-table-column prop="start_time" label="活动开始时间">
			</el-table-column>
			<el-table-column prop="end_time" label="活动结束时间"></el-table-column>

			<el-table-column fixed="right" label="数据来源" width="190">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="editSide(scope.row)">
						ME活动后台
					</span>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="数据来源" width="190">
				<template slot-scope="scope">
					<span
						class="pointer margin_left_10"
						@click="editOtherSide(scope.row)"
					>
						EXCEL导入
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { recommendactivity } from "@/api/article";
import { status } from "nprogress";

export default {
	props: ["tableData", "type"],
	components: {},
	name: "",
	data() {
		return {
			value: true,
			title: "",
		};
	},
	methods: {
		editSide(row) {
			this.$router.push({
				path: "/event/sideIndex",
				query: { id: row.id },
			});
		},

		editOtherSide(row) {
			this.$router.push({
				path: "/event/otherSideIndex",
				query: { id: row.id },
			});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped></style>
